module.exports = __webpack_public_path__ + "static/media/32.82bbe744.jpg";